interface LineSplitterProps {
    children: string
}

function LineSplitter(props: LineSplitterProps) {
    return (
        <div className={"flex flex-col space-y-2"}>
            {props.children.split("\n").map((elem, index) => (
                <div key={index}>{elem}</div>
            ))}
        </div>
    )
}

export default LineSplitter
